import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

import Link from '../../../Core/Link';
import Image from '../../../Core/Image';

export const StyledListItem = styled.li`
  overflow: hidden;
  border-radius: 0.75rem;
  background-color: ${themeGet('colors.white')};
  border: 1px solid ${themeGet('colors.border-grey')};
`;

export const Card = styled.article`
  display: flex;
  flex-direction: column;
  position: relative;
  height: 100%;
  width: 100%;
  border-radius: 0.75rem;
  background-color: ${themeGet('colors.white')};
  overflow: hidden;
`;

export const CardImage = styled(Image)`
  height: 15rem;
  width: 100%;
  background-color: ${themeGet('colors.stone')};
`;

export const ImgWrapper = styled.div`
  height: 60%;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    height: 65%;
  }
`;

export const StyledLink = styled(Link)`
  &.unstyled-link {
    display: flex;
  }
`;

export const Content = styled.div`
  display: flex;
  position: relative;
  height: 40%;
  flex-direction: column;
  text-align: center;
  padding: 1.5rem;
  gap: 1rem;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    height: 35%;
  }
`;

export const Title = styled(Link)`
  font-weight: ${themeGet('fontWeights.medium')};
  font-size: 1rem;
  line-height: 1.5rem;
  margin-bottom: 0.75rem;

  p {
    font-size: inherit;
    line-height: inherit;
  }
`;

export const Author = styled.p`
  font-weight: normal;
`;
